<template>
    <a class="p-button p-button-sm border-stone-400 bg-stone-400 cursor-auto" @click="stopHandler($event)" v-if="disabled">
        <IconShow class="mr-2" />
        <slot></slot>
    </a>
    <Link :href="url" class="p-button p-button-sm border-stone-500 bg-stone-500 hover:bg-stone-600" v-else>
        <IconShow class="mr-2" />
        <slot></slot>
    </Link>
</template>
<script>
    import { defineComponent } from 'vue'
    import { Link } from '@inertiajs/inertia-vue3';
    import IconShow from '@/Icons/Show'

    export default defineComponent({
        props: {
            url: {
                type: String,
            },
            disabled: {
                type: Boolean,
                default: false
            },
        },
        components: {
            Link,
            IconShow,
        },
        methods: {
            stopHandler: function(event){event.preventDefault()}
        }
    })
</script>